module.exports = __webpack_public_path__ + "img/NewUI-LREXLogo.ac6cd5e9.png";